module.exports = __webpack_public_path__ + "img/ss_pink_00a.4a2dc360.jpg";